import React from 'react'
import OrgLandingPageViewer from '../components/OrgLandingPageViewer'
import { useParams } from 'react-router-dom'

export default function OrgLandingPage() {
    const { orgId } = useParams()
    const orgIdNum = orgId ? parseInt(orgId, 10) : null

    if (!orgIdNum || isNaN(orgIdNum)) {
        return <div className="p-8 text-center">잘못된 조직 ID입니다.</div>
    }

    return <OrgLandingPageViewer orgId={orgIdNum} />
}
